import req from "../modules/request.module";

export function fetchOwnerReport(
  investmentId,
  investedInCompanyId,
  sortByProp,
  sortOrder,
  isCompany,
) {
  const w = window.open(
    `https://${window.location.hostname}/assets/build/misc/generating-pdf.html`,
    "_blank",
  );

  return function () {
    return req
      .get(
        `/shares/pdf/owner-report/investment/${investmentId}?companyId=${investedInCompanyId}&sortByProp=${sortByProp}&sortOrder=${sortOrder}&isCompany=${isCompany}`,
      )
      .then((response) => {
        const url = response.data;
        w.location = url;
      })
      .catch((err) => {
        console.error(err);
      });
  };
}

export function fetchOwnerReportFromApp({
  sortBy = "name",
  sortOrder = "ASC",
  ssnMasking = "high",
} = {}) {
  const w = window.open(
    `https://${window.location.hostname}/assets/build/misc/generating-pdf.html`,
    "_blank",
  );
  return function () {
    return req
      .get(
        `/shares/pdf/owner-report/?sortByProp=${sortBy}&sortOrder=${sortOrder}&ssnMasking=${ssnMasking}`,
      )
      .then((response) => {
        const url = response.data;
        w.location = url;
      })
      .catch((err) => {
        console.error(err);
      });
  };
}
